<template>
    <div id="approval">
        <!-- <van-nav-bar title="审批流程" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
        <div class="loading" v-if="loading">
            <van-loading size="44" />
        </div>
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="trackRecordList.length">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
                <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
            </van-step>
        </van-steps>
        <van-empty v-else description="暂无数据" />
        <van-form ref="form" label-width="110px" input-align="left" v-if="type == 1">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <div style="height:1.2rem;"></div>
        <div class="bottom" style="border-radius:0.1rem;overflow:hidden">
            <van-button block type="default" v-if="type == 1" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="type == 1" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
            <van-button block type="primary" v-else @click="$router.back()">返回</van-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestWorkflowDetail,
    requestWorkflowDetail1,
    requestWorkflowSubmit
} from "@/api";
export default {
    name: "approval",
    data() {
        return {
            trackRecordList: [],
            processTypeList: [
                "",
                "收房合约",
                "租房合约",
                "收房退租",
                "租房退租"
            ],
            approvalStatusList: ["", "已同意", "不同意"],
            statusList: ["", "审批中", "已完成", "取消", "挂起"],
            loading: true,
            type: 0,
            formData: {
                remark: ""
            },
            saveLoad: false
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList"
        ])
    },
    created() {
        this.type = this.$route.query.type;
        this.getWorkflow();
    },
    mounted() {},
    methods: {
        getWorkflow() {
            if (this.type == 1) {
                //审批待办
                requestWorkflowDetail1(this.$route.query.agentId).then(res => {
                    this.trackRecordList = res.data ? res.data : [];
                    this.trackRecordList[0].status == 5
                        ? (this.type = 0)
                        : (this.type = 1);
                    this.loading = false;
                });
            } else {
                //合约
                requestWorkflowDetail({
                    businessId: this.$route.query.businessId
                }).then(res => {
                    this.trackRecordList = res.data ? res.data : [];
                    this.loading = false;
                });
            }
        },
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            this.$refs["form"].validate().then(valid => {
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    this.type;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            });
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.van-steps {
    text-align: left;
    padding-left: 2rem;
    /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
            padding-top: 0.2rem;
        }
    }
}
.van-form {
    margin-top: 0.2rem;
}
.bottom {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    /deep/.van-button--primary {
        margin-left: -1px;
        border: none;
        border-radius: 0;
    }
    .font5 {
        width: 51%;
    }
}
</style>
